import { render, staticRenderFns } from "./SectionAssets.vue?vue&type=template&id=13a2e9ff&scoped=true&"
import script from "./SectionAssets.vue?vue&type=script&lang=js&"
export * from "./SectionAssets.vue?vue&type=script&lang=js&"
import style0 from "./SectionAssets.vue?vue&type=style&index=0&id=13a2e9ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a2e9ff",
  null
  
)

export default component.exports